import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const toggleChipGroupStyles = tv({
    slots: {
        base: `
      iris:center
      iris:m-0
      iris:flex
      iris:list-none
      iris:flex-wrap
      iris:gap-2
      iris:p-0
    `,
        toggleItem: `
      iris:group
      iris:inline-flex
      iris:h-(--comp-size-height-chip-toggle)
      iris:cursor-pointer
      iris:items-stretch
      iris:justify-stretch
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-chip-toggle)
      iris:p-0
      iris:duration-(--comp-motion-duration-chip-toggle)
      iris:ease-(--comp-motion-easing-chip-toggle)
    `,
        itemInteractive: `
      iris:inline-flex
      iris:px-(--comp-space-padding-chip-toggle-horizontal)
      iris:py-(--comp-space-padding-chip-toggle-vertical)
    `,
        label: `
      iris:flex
      iris:items-center
      iris:font-(family-name:--comp-type-font-chip-toggle)
      iris:text-(length:--comp-type-size-chip-toggle)
      iris:leading-(--comp-type-leading-chip-toggle)
      iris:font-(--comp-type-weight-chip-toggle)!
      iris:tracking-(--comp-type-tracking-chip-toggle)
    `,
    },
    variants: {
        inverse: {
            false: {
                toggleItem: focusStyles.default,
                itemInteractive: "",
            },
            true: {
                toggleItem: focusStyles.inverse,
                itemInteractive: "",
            },
        },
        isSelected: {
            false: {},
            true: {},
        },
    },
    compoundVariants: [
        {
            inverse: false,
            isSelected: false,
            class: {
                toggleItem: `
          iris:border-(length:--comp-size-border-chip-toggle)
          iris:border-(--comp-color-border-chip-toggle-rest)
          iris:bg-(--comp-color-background-chip-toggle-rest)
          iris:group-hover:border-(length:--comp-size-border-chip-toggle)
          iris:group-hover:border-(--comp-color-border-chip-toggle-hover)
          iris:group-active:border-(length:--comp-size-border-chip-toggle)
          iris:group-active:border-(--comp-color-border-chip-toggle-pressed)
        `,
                label: `
          iris:text-(--comp-color-content-chip-toggle-rest)
          iris:group-hover:text-(--comp-color-content-chip-toggle-hover)
          iris:group-active:text-(--comp-color-content-chip-toggle-pressed)
        `,
                itemInteractive: `
          iris:group-hover:bg-(--comp-color-background-chip-toggle-hover)
          iris:group-active:bg-(--comp-color-background-chip-toggle-pressed)
        `,
            },
        },
        {
            inverse: true,
            isSelected: true,
            class: {
                label: `
          iris:text-(--comp-color-content-chip-toggle-selected-inverse-rest)
          iris:group-hover:text-(--comp-color-content-chip-toggle-selected-inverse-hover)
          iris:group-active:text-(--comp-color-content-chip-toggle-selected-inverse-pressed)
        `,
                toggleItem: `
          iris:border-(length:--comp-size-border-chip-toggle)
          iris:border-(--comp-color-border-chip-toggle-selected-inverse-rest)
          iris:bg-(--comp-color-background-chip-toggle-selected-inverse-rest)
          iris:group-hover:border-(length:--comp-size-border-chip-toggle)
          iris:group-hover:border-(--comp-color-border-chip-toggle-selected-inverse-hover)
          iris:group-hover:bg-(--comp-color-background-chip-toggle-selected-inverse-hover)
          iris:group-active:border-(length:--comp-size-border-chip-toggle)
          iris:group-active:border-(--comp-color-border-chip-toggle-selected-inverse-pressed)
          iris:group-active:bg-(--comp-color-background-chip-toggle-selected-inverse-pressed)
        `,
                itemInteractive: `
          iris:group-hover:bg-(--comp-color-background-chip-toggle-selected-inverse--hover)
          iris:group-active:bg-(--comp-color-background-chip-toggle-selected-inverse-pressed)
        `,
            },
        },
        {
            inverse: false,
            isSelected: true,
            class: {
                label: `
          iris:text-(--comp-color-content-chip-toggle-selected-rest)
          iris:group-hover:text-(--comp-color-content-chip-toggle-selected-hover)
          iris:group-active:text-(--comp-color-content-chip-toggle-selected-pressed)
        `,
                toggleItem: `
          iris:border-(length:--comp-size-border-chip-toggle)
          iris:border-(--comp-color-border-chip-toggle-selected-rest)
          iris:bg-(--comp-color-background-chip-toggle-selected-rest)
          iris:group-hover:border-(length:--comp-size-border-chip-toggle)
          iris:group-hover:border-(--comp-color-border-chip-toggle-selected-hover)
          iris:group-active:border-(length:--comp-size-border-chip-toggle)
          iris:group-active:border-(--comp-color-border-chip-toggle-selected-pressed)
        `,
                itemInteractive: `
          iris:group-hover:bg-(--comp-color-background-chip-toggle-selected-hover)
          iris:group-active:bg-(--comp-color-background-chip-toggle-selected-pressed)
        `,
            },
        },
        {
            inverse: true,
            isSelected: false,
            class: {
                toggleItem: `
          iris:border-(length:--comp-size-border-chip-toggle)
          iris:border-(--comp-color-border-chip-toggle-inverse-rest)
          iris:bg-(--comp-color-background-chip-toggle-inverse-rest)
          iris:group-hover:border-(length:--comp-size-border-chip-toggle)
          iris:group-hover:border-(--comp-color-border-chip-toggle-inverse-hover)
          iris:group-active:border-(length:--comp-size-border-chip-toggle)
          iris:group-active:border-(--comp-color-border-chip-toggle-inverse-pressed)
        `,
                label: `
          iris:text-(--comp-color-content-chip-toggle-inverse-rest)
          iris:group-hover:text-(--comp-color-content-chip-toggle-inverse-hover)
          iris:group-active:text-(--comp-color-content-chip-toggle-inverse-pressed)
        `,
                itemInteractive: `
          iris:group-hover:bg-(--comp-color-background-chip-toggle-inverse-hover)
          iris:group-active:bg-(--comp-color-background-chip-toggle-inverse-pressed)
        `,
            },
        },
    ],
    defaultVariants: {
        inverse: false,
        isSelected: false,
    },
});

export { toggleChipGroupStyles as default };
